import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import CustomerInvoicesNavUI from './CustomerInvoicesNavUI.js'

const RfTransactionListPageUI = ({ context, account, customerInvoiceList, onRefreshClick }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cal' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account || !customerInvoiceList}
    account={account} page='rf'
  >
    {
      (!account || !customerInvoiceList) &&
      <SpinnerComponentUI />
    }
    {
      account && customerInvoiceList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Receivable Financing</b></span>
            </div>
          }
          right={
            <div className='g_flex_h'>

            </div>
          }
        />
        <CustomerInvoicesNavUI context={context} account={account} page='transactions' />
      </div>
    }

    {
      account && customerInvoiceList && customerInvoiceList.length === 0 &&
      <EmptyListUI createDisabledMessageLabel='No interest payments yet' />
    }

    {
      account && customerInvoiceList && customerInvoiceList.map((invoice, i) =>
        <CardUI key={i} title={`Customer Invoice: ${invoice.invoiceName}`} className='g_m_bottom_100'>
          <span >{invoice.customerName}</span>
          <LRTableBodyUI className='g_m_top_50'>
            {
              invoice.transactionList && invoice.transactionList.map((txn, j) =>
                <TxnRowList key={j} context={context} txn={txn} formula={invoice.formula} />
              )
            }
          </LRTableBodyUI>
        </CardUI>
      )
    }

  </SuperUserAccountPageUI>

const TxnRowList = ({ context, txn, formula }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} txn={txn} formula={formula} />}
    right={<RowRightUI txn={txn} />}
  />

const RowLeftUI = ({ txn, formula }) =>
  <div className='g_flex_v'>
    <span className=''>
      {txn.transactionDateF}
      <span className='g_muted g_m_left_50'>{txn.transactionId}</span>
    </span>
    <span className='g_muted g_small'>{formula}</span>
  </div>

const RowRightUI = ({ txn }) =>
  <div className='g_flex_v g_text_right'>
    <span>{txn.amountF1}</span>
    {
      txn.tdsAmountF2 &&
      <span className='g_muted'>TDS {txn.tdsSection} @{txn.tdsRate}% {txn.tdsAmountF2}</span>
    }
  </div>
export default RfTransactionListPageUI
